import React, { useState } from "react";
import LeafletMap from "../ext/LeafletMap";
import { POINTS_ADMIN } from "../../../config/lang";
import { translate } from "../../../util/util";

async function geocodeSearch(query) {
  const url = "https://nominatim.openstreetmap.org/search?format=json&limit=1&q=" + encodeURIComponent(query);
  const res = await fetch(url);
  const results = await res.json();
  return results && results[0] ? results[0] : null;
}

async function geocodeReverse(lat, lng) {
  const url = "https://nominatim.openstreetmap.org/reverse?format=json&lat=" + lat + "&lon=" + lng;
  const res = await fetch(url);
  return res.json();
}

export default function LocationPickerField({ field, value, onChange, item, labels = {}, lang }) {
  const G = POINTS_ADMIN;
  const [searchText, setSearchText] = useState((item && item.address) || "");
  const [status, setStatus] = useState(null);

  const lat = value ? value.latitude : "";
  const lng = value ? value.longitude : "";

  const emitCoords = (nextLat, nextLng) => {
    if (nextLat === "" && nextLng === "") return onChange(field.name, null);
    onChange(field.name, { latitude: Number(nextLat), longitude: Number(nextLng) });
  };

  const runSearch = async () => {
    if (!searchText || !searchText.trim()) return;
    setStatus("searching");
    try {
      const result = await geocodeSearch(searchText);
      if (result) {
        onChange(field.name, { latitude: Number(result.lat), longitude: Number(result.lon) });
        onChange("address", result.display_name);
        setStatus(null);
      } else {
        setStatus("not_found");
      }
    } catch (e) {
      setStatus("not_found");
    }
  };

  const reverseGeocode = async (rLat, rLng) => {
    try {
      const result = await geocodeReverse(rLat, rLng);
      if (result && result.display_name) {
        onChange("address", result.display_name);
      }
    } catch (e) {
      // ignore reverse geocode failures, never crash the form
    }
  };

  const handleSearchKeyDown = e => {
    if (e.key === "Enter") {
      e.preventDefault();
      runSearch();
    }
  };

  return (
    <div className="mp-form-group">
      <label className="mp-form-label">{field._label}</label>

      <div className="pt-loc-search">
        <input
          type="text"
          className="mp-form-input"
          placeholder={translate(G, "search_address", lang) || "Search address"}
          value={searchText}
          onChange={e => setSearchText(e.target.value)}
          onKeyDown={handleSearchKeyDown}
        />
        <button type="button" className="mp-toggle-btn" onClick={runSearch}>
          {translate(G, "search_btn", lang) || "Search"}
        </button>
      </div>
      {status && (
        <div className="pt-loc-status">
          {status === "searching"
            ? (translate(G, "searching", lang) || "Searching…")
            : (translate(G, "not_found", lang) || "Not found")}
        </div>
      )}

      <div className="pt-loc-coords">
        <input
          type="number"
          step="any"
          className="mp-form-input"
          placeholder={labels.lat}
          value={lat}
          onChange={e => emitCoords(e.target.value, lng)}
        />
        <input
          type="number"
          step="any"
          className="mp-form-input"
          placeholder={labels.lng}
          value={lng}
          onChange={e => emitCoords(lat, e.target.value)}
        />
      </div>

      <LeafletMap
        lat={value && value.latitude}
        lng={value && value.longitude}
        zoom={value ? 15 : 6}
        editable
        onChange={({ lat: newLat, lng: newLng }) => {
          onChange(field.name, { latitude: newLat, longitude: newLng });
          setStatus(null);
          reverseGeocode(newLat, newLng);
        }}
        height={300}
      />
    </div>
  );
}
